import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tag-data" }

import CopyToClipboard from '@shell/components/Resource/Detail/CopyToClipboard.vue';
import { Row } from '@shell/components/Resource/Detail/Metadata/KeyValue.vue';
import Preview from '@shell/components/Resource/Detail/Preview/Preview.vue';
import { nextTick, ref } from 'vue';
import RcTag from '@components/Pill/RcTag/RcTag.vue';
import RcButton from '@components/RcButton/RcButton.vue';
import { Type } from '@components/Pill/types';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import { randomStr } from '@shell/utils/string';

export interface KeyValueRowProps {
    row: Row;
    type: Type;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KeyValueRow',
  props: {
    row: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const i18n = useI18n(store);

const showPreview = ref(false);
const element = ref<HTMLElement | null>(null);
const button = ref<HTMLElement | null>(null);

const onClose = (keyboardExit: boolean) => {
  showPreview.value = false;
  if (keyboardExit) {
    nextTick(() => {
      button.value?.focus();
    });
  }
};
const previewId = randomStr();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "element",
    ref: element,
    class: _normalizeClass(["key-value-row", {'show-preview': showPreview.value, [props.type]: true}])
  }, [
    _createVNode(RcButton, {
      ref_key: "button",
      ref: button,
      variant: "ghost",
      "aria-haspopup": "dialog",
      "aria-expanded": showPreview.value,
      "aria-controls": _unref(previewId),
      "aria-label": _unref(i18n).t('component.resource.detail.metadata.keyValue.ariaLabel.showPreview'),
      onClick: _cache[0] || (_cache[0] = () => showPreview.value = true)
    }, {
      default: _withCtx(() => [
        _createVNode(RcTag, {
          type: __props.type,
          highlight: showPreview.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(props.row.key) + ": " + _toDisplayString(props.row.value), 1)
          ]),
          _: 1
        }, 8, ["type", "highlight"])
      ]),
      _: 1
    }, 8, ["aria-expanded", "aria-controls", "aria-label"]),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createVNode(CopyToClipboard, {
      value: __props.row.value
    }, null, 8, ["value"]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    (showPreview.value)
      ? (_openBlock(), _createBlock(Preview, {
          key: 0,
          id: _unref(previewId),
          class: "preview",
          title: __props.row.key,
          value: __props.row.value,
          "anchor-element": element.value,
          "aria-live": "polite",
          onClose: onClose
        }, null, 8, ["id", "title", "value", "anchor-element"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})